<div fxLayout="row" mat-dialog-title>
    <div fxFlex>
        <h2 mat-dialog-title>Gestion des vaccins</h2>
    </div>
    <div fxFlex="80px">
        <button mat-icon-button (click)="addVaccine()"><fa-icon [icon]="['fas','plus-circle']" size="2x"></fa-icon></button>
    </div>
</div>
<mat-dialog-content class="vaccines-list">
    <div fxLayout="row" class="vaccines-list">
        <div fxFlex="450px" class="vaccines-list">
            <mat-selection-list #shoes [multiple]="false">
                <mat-list-option *ngFor="let vaccine of vaccines" [value]="vaccine" (click)="select(vaccine)">
                    {{vaccine.value}}
                </mat-list-option>
            </mat-selection-list>            
        </div>
        <div fxFlex>
            <app-vaccine [vaccine]="selectedVaccine"></app-vaccine>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-stroked-button (click)="close()">Fermer</button>
</mat-dialog-actions>